<template>
  <v-dialog v-model="dialog" persistent scrollable max-width="620px">
    <v-card class="profile-dialog-card entity-form-dialog">
      <div class="profile-dialog-header entity-form-dialog__header">
        <div class="entity-form-dialog__title">
          <v-avatar size="44" color="green lighten-5"><v-icon color="primary">mdi-book-education-outline</v-icon></v-avatar>
          <div><span>Virtual classrooms</span><h2>{{ isEdit ? "Edit classroom" : "New classroom" }}</h2><p>Group students by curriculum and learning level.</p></div>
        </div>
        <v-btn icon aria-label="Close classroom dialog" @click="close"><v-icon>mdi-close</v-icon></v-btn>
      </div>
      <v-divider />
      <v-card-text class="profile-dialog-body entity-form-dialog__body">
        <v-row>
          <v-col cols="12"><v-text-field v-model="form.name" outlined dense label="Classroom name" placeholder="For example: Para 1–10" :error-messages="fieldErrors('name')" /></v-col>
          <v-col cols="12"><v-autocomplete v-model="form.ClassId" :items="departments" item-text="name" item-value="id" :loading="optionsLoading" outlined dense label="Department" :error-messages="fieldErrors('ClassId')" /></v-col>
          <v-col cols="12"><v-autocomplete v-model="form.CurriculumId" :items="curriculums" item-text="name" item-value="id" :loading="optionsLoading" outlined dense label="Curriculum (optional)" hint="You can assign one or more curriculums later from Manage curriculums." persistent-hint /></v-col>
          <v-col cols="12"><v-textarea v-model="form.description" outlined dense rows="2" auto-grow label="Description" /></v-col>
        </v-row>
      </v-card-text>
      <v-divider />
      <v-card-actions class="profile-dialog-actions entity-form-dialog__actions">
        <v-btn text @click="close">Cancel</v-btn><v-spacer />
        <v-btn color="primary" depressed :loading="saving" @click="submit">{{ isEdit ? "Save changes" : "Create classroom" }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import classesService from "@/modules/Classes/service.js";
import curriculumService from "@/modules/ReportCard/Curriculums/service.js";
import service from "../service.js";

export default {
  props: { value: Boolean, classroom: { type: Object, default: null } },
  data: () => ({ dialog: false, saving: false, optionsLoading: false, departments: [], curriculums: [], touched: false, form: { name: "", description: "", ClassId: null, CurriculumId: null } }),
  computed: { isEdit() { return Boolean(this.classroom && this.classroom.id); } },
  watch: {
    value: { immediate: true, handler(value) { this.dialog = value; if (value) this.open(); } },
    dialog(value) { if (!value && this.value) this.$emit("input", false); },
  },
  methods: {
    fieldErrors(field) { return this.touched && !this.form[field] ? [field === "name" ? "Classroom name is required" : "Department is required"] : []; },
    async open() {
      this.touched = false;
      this.form = this.classroom ? { name: this.classroom.name, description: this.classroom.description, ClassId: this.classroom.ClassId, CurriculumId: this.classroom.CurriculumId || (this.classroom.Curriculum && this.classroom.Curriculum.id) } : { name: "", description: "", ClassId: null, CurriculumId: null };
      this.optionsLoading = true;
      try {
        const responses = await Promise.all([classesService.getAll(), curriculumService.getAll()]);
        this.departments = responses[0].data || [];
        this.curriculums = responses[1].data || [];
      } finally { this.optionsLoading = false; }
    },
    close() { this.dialog = false; this.$emit("input", false); },
    async submit() {
      this.touched = true;
      if (!this.form.name || !this.form.ClassId) return;
      this.saving = true;
      try {
        if (this.isEdit) await service.update(this.classroom.id, this.form); else await service.create(this.form);
        this.$swal.mixin({ toast: true, position: "top-end", showConfirmButton: false, timer: 3000 }).fire({ icon: "success", title: this.isEdit ? "Classroom updated" : "Classroom created" });
        this.$emit("saved"); this.close();
      } catch (error) {
        this.$swal({ title: "Unable to save classroom", text: error && error.data && error.data.message ? error.data.message : "Please try again.", icon: "error" });
      } finally { this.saving = false; }
    },
  },
};
</script>
